import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    useMediaQuery
} from "@mui/material";
import { useTranslate } from "react-admin";
import jwt_decode from "jwt-decode";

const getUserData = () => {
    try {
        return localStorage.token ? jwt_decode(localStorage.token) : null;
    } catch (error) {
        console.error("Invalid token:", error);
        return null;
    }
};

const Welcome = () => {
    const translate = useTranslate();
    const isTablet = useMediaQuery("(max-width: 1024px)"); // Detects iPad-sized screens
    const user = getUserData();

    return (
        <Box sx={{ 
            display: "flex",
            justifyContent: "flex-start", // Aligns box to the left
            alignItems: "center", 
            width: "100%", 
            px: 0, // isTablet ? 2 : 4, // Adds spacing on smaller screens
        }}>
            <Card 
                sx={{ 
                    width: "100%", 
                    maxWidth: isTablet ? "90%" : 600, 
                    boxShadow: 4, 
                    borderRadius: 3, 
                    background: "linear-gradient(to right,rgb(11, 23, 92),rgb(0, 110, 254))", 
                    color: "white", 
                    textAlign: "left",  // Aligns text to the left
                    p: 0.1,
                    minHeight: "120px", // Ensures the card stays compact
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                }}
            >
                <CardContent sx={{ p: 1 }}>
                    <Typography 
                        variant="h5" 
                        sx={{ fontWeight: "bold", mb: 1 }}
                    >
                        Welcome to HemDonER Donor Management System
                    </Typography>
                    <Typography 
                        variant="h6" 
                        sx={{ mb: 1, fontSize: isTablet ? "16px" : "18px" }}
                    >
                        Hello, {user?.full_name || "User"}!
                    </Typography>
                    <Typography 
                        variant="body1" 
                        sx={{ fontSize: "14px", opacity: 0.9 }}
                    >
                        {user?.title || "Your Title"} at {user?.location || "Your Location"}
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Welcome;
